import React, { useState, useEffect } from "react";
import { AgChartsReact } from "ag-charts-react";
import { server } from "../../App";
import { useQuery } from "react-query";
import axios from "axios";
import moment from "moment";
import { YearsOptions } from "../Consultation/bloc3/DropdownOptions/AvOptions";
import { Form, Dropdown } from "semantic-ui-react";
import { GetProducts2 } from "../Api/api";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useWindowSize } from "react-use";
import useGetDoctorsSemanticUI from "../../CustomHooks/useGetDoctorsSemanticUI"

function ByProdducts() {
  const [Year, setYear] = useState(moment().format("YYYY"));
  const [ProdID, setProdID] = useState(0);
  const [fk_id_medecin1, setfk_id_medecin1] = useState(0);
  const { width } = useWindowSize();

  const Doctors = useGetDoctorsSemanticUI()

  let myObject = { key: "0000000A", text: "Global", value: 0 }
  let myObject2 = Doctors?.Doctors_list ? Doctors?.Doctors_list : []

  myObject2.push(myObject)

  // https://aniba.ddns.net/products/

  const { data: prodIds } = useQuery("Get_Products", () => {
    return GetProducts2();
  });

  const listeDeProd = prodIds?.data?.map((oneProd, i) => (
    <option key={i} className="prodItem" value={oneProd.id_acte}>
      {oneProd.nom_acte} - {oneProd.prix_acte} DH
    </option>
  ));

  const getData = () => {
    let url;


    // DEV
    // if (fk_id_medecin1 == 0) {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/GetRevenuByAct/${ProdID}/${Year}`;
    // } else {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/GetRevenuByAct/${ProdID}/${Year}/${fk_id_medecin1}`;
    // }

    // PROD
    if (fk_id_medecin1 == 0) {
      url = `${server}StatisticsRoutes/GetRevenuByAct/${ProdID}/${Year}`;
    } else {
      url = `${server}StatisticsRoutes/GetRevenuByAct/${ProdID}/${Year}/${fk_id_medecin1}`;
    }


    return axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => response.data);
  };
  const { data, refetch } = useQuery("ByProduct", () => {
    return getData();
  });
  useEffect(() => {
    refetch();
  }, [ProdID, Year, fk_id_medecin1]);

  let options = {
    title: {
      text: "Revenu par acte du centre",
    },
    subtitle: {
      text: "En Dirham",
    },
    data: data,
    series: [
      {
        type: "column",
        xKey: "Mois",
        yKeys: ["Total"],
        yName: "Total",
      },
    ],
    legend: {
      position: 'bottom',
    },

  };

  let angle
  if (width < 512) {
    angle = 359
  } else {
    angle = 30
  }

  let options2 = {
    title: {
      text: "Nombre d'actes",
    },
    subtitle: {
      text: "Par mois",
    },
    data: data,
    series: [
      {
        type: "pie",
        labelKey: "Mois",
        angleKey: "Nombre",
        label: {
          minAngle: angle
        }
      },
    ],
    legend: {
      position: 'bottom',
    },
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      fontWeight: 900,
      fontSize: "1.2rem",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
    <>
      <div className="FixingAbigProblem">


        <Form.Field
          className="TinySelect"
          value={Year}
          search
          selection
          fluid
          label="Année"
          control={Dropdown}
          options={YearsOptions}
          placeholder="Année"
          onChange={(e, data) => {
            setYear(data.value);
          }}
        />


        <Form.Field
          className="TinySelect"
          value={fk_id_medecin1}
          search
          selection
          fluid
          label="Médecin"
          control={Dropdown}
          options={myObject2}
          // placeholder="Médecin"
          onChange={(e, data) => {
            setfk_id_medecin1(data.value);
          }}
        />
      </div>
      <div className="fixingAbigproblem2">
        <select
          style={{ width: "3rem", marginTop: "0.8rem" }}
          // role="listbox"
          value={ProdID}
          aria-expanded="false"
          className="ui selection dropdown prodItem2"
          required
          onChange={(e) => {
            setProdID(e.target.value);
          }}
        >
          <option className="prodItem" value="0">
            Produit
          </option>
          {listeDeProd}
        </select>
      </div>
      <AgChartsReact options={options} />
      <AgChartsReact options={options2} />

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 260 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Acte</StyledTableCell>
              <StyledTableCell>Mois</StyledTableCell>
              <StyledTableCell>Nb</StyledTableCell>
              <StyledTableCell>Total</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((item, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell>{item.Acte}</StyledTableCell>
                <StyledTableCell>{item.Mois}</StyledTableCell>
                <StyledTableCell>{item.Nombre}</StyledTableCell>
                <StyledTableCell>{new Intl.NumberFormat('de-DE').format(item.Total)}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default ByProdducts;
